export type QuillDelta = {
  ops?: Array<Record<string, unknown>>
}

export const parseQuillDelta = (raw: unknown): QuillDelta | null => {
  if (!raw) {
    return null
  }

  if (typeof raw === 'string') {
    try {
      return parseQuillDelta(JSON.parse(raw))
    } catch {
      return null
    }
  }

  if (typeof raw !== 'object' || Array.isArray(raw)) {
    return null
  }

  const ops = (raw as QuillDelta).ops
  if (!Array.isArray(ops) || ops.length === 0) {
    return null
  }

  return raw as QuillDelta
}

export const hasQuillDelta = (delta?: QuillDelta | null): boolean =>
  Boolean(delta && Array.isArray(delta.ops) && delta.ops.length > 0)
